import { makeSvgIcon } from '../makeSvgIcon'

export const diamond = makeSvgIcon(<path d="M5 12L12 1L19 12L12 23L5 12Z" />)
